/**
 * Freeze/"unfreeze" objects
 * @module
 */

var _ = require('optimizely-client-fn');

var SHOULD_FREEZE = __EXPERIMENTAL_FREEZE_DATA__;

/**
 * If `__EXPERIMENTAL_FREEZE_DATA__`, convert obj into a {FrozenObject}
 * @param {Object} obj Object to freeze
 */
exports.deepFreeze = function deepFreeze(obj:any) {
  if (!SHOULD_FREEZE) {
    return;
  }

  if (_.isObject(obj) && !_.isFunction(obj)) {
    _.forOwn(obj, deepFreeze);

    Object.freeze(obj);
  }
};

/**
 * Return a "safe" reference to obj (i.e. one that cannot be mutated to mutate obj).
 * If obj is frozen or otherwise immutable, returns obj itself.
 * @param {Object|FrozenObject} obj
 * @return {SafeReference}
 */
exports.safeReference = function safeReference(obj:any|FrozenObject): SafeReference {
  if (SHOULD_FREEZE) {
    if (!_.isObject(obj) || _.isFunction(obj) || Object.isFrozen(obj)) {
      return obj;
    }

    if (_.isArray(obj)) {
      return _.map(obj, safeReference);
    }

    return _.reduce(obj, function(res, val, key) {
      res[key] = safeReference(val);
      return res;
    }, {});
  }

  return _.cloneDeep(obj);
};

if (__TEST__) {
  exports.__shouldFreeze = function() {
    return SHOULD_FREEZE;
  };

  exports.__setShouldFreeze = function(shouldFreeze) {
    SHOULD_FREEZE = shouldFreeze;
  };
}
